import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getScenicArea(condition = { id: -1 }) {
  let response = {}
  let id = Utils.isEmptyObject(condition.id) ? -1 : condition.id
  let idQuery = id < 0 ? '' : `/${id}`
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/ScenicArea${idQuery}`)

  } catch (err) {
    console.error('iisi getScenicArea: ', err)
    return null
  }

  if(!Utils.isEmptyObject(response.data)){
    response.data.sort((a, b) => {
      return a.areasSort - b.areasSort < 0 ? -1 : 1
    })
  }

  return { scenicAreaData: response.data, id: id }
}

export async function getDeviceByScenicAreaId(condition = { id: -1 }) {
  let response = {}
  let id = Utils.isEmptyObject(condition.id) ? -1 : condition.id
  if (id < 0) {
    console.error('iisi getDeviceByScenicAreaId: id error')
    return
  }

  // console.log("con",condition);
  let scenicAreaIdQuery = "";
  if(condition.id.length > 1) {
    const query = condition.id.map((scenicAreaId) => `scenicAreaIds=${scenicAreaId}`).join('&');
     scenicAreaIdQuery =  "?"+ query;

  }else{
    scenicAreaIdQuery = `?scenicAreaIds=${condition.id}`
  }
  // let idQuery = `/${id}`
  try {
    // response = await axios.get(`${config.eastCoastDataApi()}BaseData/ScenicArea${idQuery}/Devices`)
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/ScenicArea/Devices${scenicAreaIdQuery}`)
    // https://localhost:44394/api/BaseData/ScenicArea/Devices?scenicAreaIds=1&scenicAreaIds=2&scenicAreaIds=3


  } catch (err) {
    console.error('iisi getDeviceByScenicAreaId: ', err)
    return null
  }

  return response.data
}

export async function putScenicArea(scenicArea = {}) {
  if(Utils.isEmptyObject(scenicArea.id) || scenicArea.id < 0) {
    console.error('iisi putScenicArea: id error')
    return
  }

  let response = {}
  let idQuery = `/${scenicArea.id}`

  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/ScenicArea${idQuery}`, scenicArea)

  } catch (err) {
    console.error('iisi putScenicArea: ', err)

  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function postScenicArea(scenicArea = {}) {
  if(Utils.isEmptyObject(scenicArea) || Utils.isEmptyString(scenicArea.name) || scenicArea.areasSort < 0) {
    console.error('iisi postScenicArea: id error')
    return {}
  }

  scenicArea.fullSizeCarNumber = 0
  scenicArea.compactCarNumber = 0
  scenicArea.motorcycleNumber = 0
  scenicArea.isDeleted = false
  let response = {}

  try {
    response = await axios.post(`${config.eastCoastDataApi()}BaseData/ScenicArea`, scenicArea)

  } catch (err) {
    console.error('iisi postScenicArea: ', err)

  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function getRoleToScenicArea(roleIds = []) {
  let response = {}
  if(Utils.isEmptyObject(roleIds)) {
    console.error('iisi getRoleToScenicArea: roleIds error')
    return response
  }

  let queryString = ''
  roleIds.forEach((id, index) => {
    if(index === 0) {
      queryString = id
    } else {
      queryString = `${queryString}&roleIds=${id}`
    }
  })


  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/RoleToScenicArea?roleIds=${queryString}`)
  } catch (err) {
    console.error('iisi getRoleToScenicArea: ', err)

  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function deleteScenicArea(scenicArea = {}) {
  if(Utils.isEmptyObject(scenicArea.id) || scenicArea.id < 0) {
    console.error('iisi deleteScenicArea: id error')
    return
  }

  let response = {}
  let idQuery = `/${scenicArea.id}`

  try {
    response = await axios.delete(`${config.eastCoastDataApi()}BaseData/ScenicArea${idQuery}`)

  } catch (err) {
    if(err.response && err.response.status === 409){
      return err.response;
      }else{
      console.error('iisi deleteDevice: ', err)
      return null

  }

  }

  Utils.setApiResponsSuccess(response)
  return response
}